const registeredModals = {
	options: () => import('/views/modals/options'),
	confirm: () => import('/views/modals/confirm'),
	message: () => import('/views/modals/message'),
	agreement: () => import('/views/modals/agreement'),
	auth: () => import('/views/modals/auth'),
	otpPin: () => import('/views/modals/otp-pin'),
	notifications: () => import('/views/modals/notifications'),
	paymentCardSelection: () => import('/views/modals/payment-card-selection'),
	tableNumberConfirmation: () => import('/views/modals/table-number-confirmation'),
	guestUser: () => import('/views/modals/guest-user'),
	languages: () => import('/views/modals/languages'),
	bankRedirect: () => import('/views/modals/bank-redirect'),
	productNutritionValues: () => import('/views/modals/product-nutrition-values'),
	lotteryQr: () => import('/views/modals/lottery-qr'),
};

export default registeredModals;
